var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 309,
    viewBox: "0 0 273 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_39137)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.567 291.751C201.233 283.582 205.702 271.343 201.046 260.99C194.268 271.408 183.11 279.612 170.174 283.691C165.135 285.279 159.341 286.59 156.6 290.596C154.895 293.089 154.771 296.212 155.539 299.035C156.307 301.858 157.889 304.455 159.456 307.016L159.465 307.74C171.728 304.616 183.901 299.921 192.567 291.751Z",
    fill: "url(#paint0_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M200.787 261.044C199.326 270.06 194.545 278.728 187.234 285.262C185.647 286.74 183.847 287.97 181.893 288.909C179.883 289.801 177.691 290.207 175.495 290.093C173.426 290.027 171.319 289.752 169.268 290.124C168.262 290.301 167.302 290.68 166.446 291.237C165.589 291.794 164.854 292.518 164.283 293.367C162.924 295.369 162.472 297.678 162.121 299.948C161.731 302.469 161.371 305.093 159.714 307.262C159.513 307.525 159.993 307.781 160.194 307.518C163.078 303.745 162.113 298.923 164.059 294.854C164.967 292.955 166.538 291.283 168.887 290.709C170.941 290.208 173.114 290.491 175.208 290.573C177.354 290.71 179.504 290.384 181.513 289.619C183.515 288.77 185.366 287.603 186.996 286.163C190.565 283.11 193.614 279.495 196.025 275.462C198.7 271.043 200.508 266.153 201.35 261.054C201.401 260.743 200.837 260.734 200.787 261.044Z",
    fill: "url(#paint1_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.738 283.247C191.226 284.171 192.965 284.607 194.713 284.495C196.46 284.384 198.13 283.729 199.488 282.623C199.746 282.401 199.361 282.043 199.104 282.265C197.84 283.297 196.286 283.906 194.659 284.007C193.032 284.109 191.414 283.696 190.033 282.829C189.741 282.642 189.448 283.061 189.738 283.247Z",
    fill: "url(#paint2_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.538 290.246C176.249 288.672 176.296 287.053 176.676 285.498C177.056 283.942 177.761 282.485 178.744 281.222C178.944 280.958 178.463 280.703 178.264 280.966C177.243 282.282 176.513 283.8 176.122 285.419C175.73 287.039 175.685 288.723 175.991 290.361C176.051 290.672 176.598 290.556 176.538 290.246Z",
    fill: "url(#paint3_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M197.985 270.912C197.371 270.692 196.823 270.32 196.393 269.828C195.962 269.337 195.665 268.744 195.528 268.106C195.472 267.793 194.925 267.91 194.98 268.22C195.135 268.925 195.464 269.579 195.938 270.122C196.412 270.666 197.014 271.081 197.691 271.33C197.755 271.362 197.828 271.371 197.899 271.357C197.969 271.342 198.032 271.304 198.078 271.249C198.097 271.221 198.11 271.19 198.115 271.157C198.121 271.124 198.119 271.091 198.11 271.059C198.101 271.027 198.085 270.997 198.064 270.971C198.042 270.946 198.016 270.926 197.985 270.912Z",
    fill: "url(#paint4_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.951 249.216C159.98 249.412 160.008 249.608 160.033 249.806C160.398 252.435 160.517 255.092 160.388 257.743C160.382 257.948 160.372 258.156 160.359 258.36C159.951 264.81 158.195 271.102 155.206 276.829C153.99 279.167 152.586 281.402 151.008 283.512C148.808 286.457 146.154 289.497 145.228 292.804C145.128 293.146 145.051 293.496 145 293.849L158.449 307.691C158.498 307.709 158.543 307.73 158.592 307.749L159.1 308.323C159.191 308.218 159.283 308.107 159.374 308.002C159.427 307.941 159.477 307.878 159.53 307.817C159.564 307.775 159.599 307.734 159.632 307.698C159.644 307.684 159.655 307.671 159.663 307.659C159.697 307.624 159.724 307.587 159.754 307.554C160.269 306.938 160.78 306.317 161.286 305.691C161.29 305.689 161.29 305.689 161.29 305.683C165.136 300.91 168.558 295.817 170.983 290.433C171.056 290.271 171.132 290.106 171.199 289.938C172.27 287.525 173.118 285.018 173.732 282.449C174.059 281.055 174.305 279.642 174.47 278.219C174.885 274.545 174.633 270.827 173.726 267.243C171.915 260.063 167.485 253.466 160.489 249.514C160.31 249.413 160.134 249.315 159.951 249.216Z",
    fill: "url(#paint5_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.781 249.398C164.854 257.362 167.035 266.787 165.72 275.834C165.482 277.825 164.893 279.758 163.979 281.543C162.963 283.337 161.481 284.822 159.69 285.84C157.993 286.871 156.119 287.754 154.74 289.126C154.061 289.794 153.55 290.614 153.248 291.517C152.947 292.421 152.863 293.384 153.004 294.326C153.304 296.637 154.541 298.717 155.832 300.714C157.265 302.931 158.794 305.215 158.971 307.814C158.993 308.129 159.553 308.082 159.532 307.768C159.223 303.244 155.116 299.899 153.853 295.631C153.264 293.64 153.362 291.481 154.84 289.793C156.133 288.317 158.064 287.405 159.793 286.374C161.56 285.397 163.062 284.001 164.167 282.309C165.18 280.575 165.854 278.664 166.153 276.678C166.888 272.278 166.821 267.781 165.956 263.404C164.972 258.32 163.032 253.469 160.238 249.111C160.063 248.836 159.607 249.124 159.781 249.398Z",
    fill: "url(#paint6_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.325 272.913C170.008 272.879 173.151 270.475 173.678 267.308C173.73 266.996 173.175 266.911 173.123 267.223C172.63 270.19 169.714 272.393 166.271 272.425C165.908 272.428 165.964 272.916 166.325 272.913Z",
    fill: "url(#paint7_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.629 285.416C159.355 284.4 158.301 283.134 157.53 281.697C156.759 280.26 156.288 278.681 156.145 277.055C156.122 276.74 155.562 276.788 155.584 277.102C155.737 278.794 156.231 280.436 157.037 281.93C157.842 283.424 158.943 284.739 160.271 285.794C160.535 286.012 160.892 285.632 160.629 285.416Z",
    fill: "url(#paint8_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M164.371 258.742C163.691 258.88 162.988 258.867 162.313 258.702C161.638 258.537 161.008 258.225 160.467 257.789C160.207 257.569 159.85 257.948 160.109 258.167C160.708 258.647 161.405 258.99 162.15 259.174C162.896 259.358 163.672 259.377 164.425 259.23C164.575 259.201 164.693 259.106 164.679 258.963C164.665 258.893 164.626 258.832 164.569 258.791C164.512 258.75 164.441 258.733 164.371 258.742Z",
    fill: "url(#paint9_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.262 258.881C104.522 270.343 87.8784 273.252 74.3971 267.072C57.0967 259.142 46.6168 237.309 45.6445 207.17L46.6694 207.266C47.6279 236.985 57.86 258.468 74.7418 266.206C87.8617 272.22 104.146 269.33 120.595 258.067L121.262 258.881Z",
    fill: "url(#paint10_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.709 64.8114C223.061 83.0002 218.365 102.179 210.999 120.684C201.891 143.569 189.447 163.725 175.012 178.974L174.211 178.275C188.576 163.099 200.964 143.032 210.034 120.242C218.231 99.6475 223.107 78.2159 224.14 58.2734L225.164 58.4451C225.055 60.5512 224.904 62.6734 224.709 64.8114Z",
    fill: "url(#paint11_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.241 38.9613L179.246 39.0705C174.809 21.6101 166.209 9.51375 154.374 4.08889C139.33 -2.80707 120.727 1.8237 101.992 17.1283C83.1613 32.5111 66.4916 56.8093 55.0535 85.5479L54.0879 85.1054C65.5762 56.2413 82.3315 31.8257 101.267 16.3574C120.298 0.810916 139.281 -3.8538 154.719 3.22272C166.893 8.80303 175.718 21.1613 180.241 38.9613Z",
    fill: "url(#paint12_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.457 190.974C215.182 223.276 190.585 246.355 166.195 255.961L165.701 255.055C189.922 245.516 214.376 222.554 234.558 190.4L235.457 190.974Z",
    fill: "url(#paint13_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.74 118.602C266.405 122.289 265.977 126.02 265.455 129.797L264.438 129.55C268.34 101.367 266.956 75.5264 260.434 54.8166L261.414 54.6523C267.102 72.718 268.911 94.6455 266.74 118.602Z",
    fill: "url(#paint14_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9765 90.6035C52.3741 96.0935 49.8989 101.781 47.6194 107.508C34.5019 140.466 27.8546 174.125 28.3978 204.847L27.3726 204.737C26.8288 173.901 33.4953 140.126 46.6538 107.066C48.9398 101.322 51.4222 95.6188 54.032 90.1133L54.9765 90.6035Z",
    fill: "url(#paint15_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77 281.528C104.03 292.989 87.3863 295.898 73.9049 289.719C56.6045 281.789 46.1246 259.955 45.1523 229.816L46.1772 229.913C47.1357 259.632 57.3678 281.114 74.2496 288.853C87.3696 294.867 103.654 291.976 120.103 280.714L120.77 281.528Z",
    fill: "url(#paint16_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.217 87.4579C222.569 105.647 217.872 124.826 210.507 143.331C201.399 166.215 188.955 186.371 174.52 201.621L173.719 200.921C188.084 185.745 200.471 165.678 209.542 142.888C217.739 122.294 222.614 100.862 223.648 80.9199L224.671 81.0915C224.563 83.1977 224.411 85.3198 224.217 87.4579Z",
    fill: "url(#paint17_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.413 62.8637L221.418 62.9728C216.981 45.5125 208.381 33.4161 196.546 27.9912C181.502 21.0953 162.898 25.726 144.163 41.0307C125.333 56.4135 108.663 80.7116 97.2253 109.45L96.2598 109.008C107.748 80.1436 124.503 55.728 143.439 40.2597C162.47 24.7133 181.453 20.0485 196.891 27.1251C209.065 32.7054 217.89 45.0636 222.413 62.8637Z",
    fill: "url(#paint18_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.129 221.578C213.854 253.879 189.256 276.959 164.866 286.565L164.373 285.659C188.594 276.119 213.048 253.158 233.23 221.004L234.129 221.578Z",
    fill: "url(#paint19_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.247 141.249C265.913 144.935 265.485 148.667 264.963 152.443L263.946 152.196C267.848 124.013 266.464 98.1728 259.941 77.4631L260.921 77.2988C266.61 95.3644 268.419 117.292 266.247 141.249Z",
    fill: "url(#paint20_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4843 113.248C51.882 118.738 49.4067 124.426 47.1272 130.153C34.0097 163.111 27.3624 196.769 27.9056 227.491L26.8804 227.382C26.3366 196.545 33.0031 162.771 46.1616 129.71C48.4477 123.967 50.93 118.263 53.5399 112.758L54.4843 113.248Z",
    fill: "url(#paint21_linear_222_39137)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.612 97.3568C251.745 95.651 251.074 93.2092 249.113 91.9028C247.153 90.5965 244.644 90.9203 243.511 92.6261C242.378 94.332 243.048 96.7739 245.009 98.0802C246.97 99.3865 249.478 99.0627 250.612 97.3568Z",
    fill: "url(#paint22_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.652 229.256C63.785 227.55 63.114 225.108 61.153 223.802C59.193 222.496 56.684 222.819 55.551 224.525C54.418 226.231 55.088 228.673 57.049 229.979C59.01 231.286 61.518 230.962 62.652 229.256Z",
    fill: "url(#paint23_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35 119.102C122.723 115.461 126.597 112.599 130.912 112.357C135.228 112.115 140.413 115.795 142.543 119.582C146.439 126.508 144.748 133.168 139.383 137.985C138.654 137.737 136.11 136.99 135.369 136.751L134.899 135.901L134.32 136.418C127.689 137.08 121.284 136.342 116.293 131.394C116.913 127.089 117.977 122.744 120.35 119.102Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.129 167.717L137.345 174.997L137.806 184.545L116.689 182.032L114.705 167.717L117.233 167.742L138.129 167.717Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.458 136.255C134.301 136.255 138.227 132.324 138.227 127.474C138.227 122.625 134.301 118.693 129.458 118.693C124.615 118.693 120.689 122.625 120.689 127.474C120.689 132.324 124.615 136.255 129.458 136.255Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.041 145.291L125.067 141.323L135.117 140L144 145.953L143.911 164.138L138.276 183L114.657 179.032L113.76 172.379C113.76 172.379 107.227 160.832 114.263 154.219L120.041 145.291Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.179 114.138C128.079 113.605 130.087 113.592 131.994 114.102C133.9 114.612 135.635 115.625 137.016 117.036C138.398 118.447 139.375 120.204 139.847 122.123C140.318 124.041 140.266 126.052 139.696 127.944C134.356 128.37 129.077 127.871 124.916 124.087L124.545 120.842L123.027 123.558C121.496 123.126 119.962 122.692 118.426 122.255C118.896 120.341 119.859 118.584 121.22 117.16C122.58 115.735 124.29 114.693 126.179 114.138Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6261 102.759C89.3884 103.267 89.2646 103.821 89.2637 104.381C89.2627 104.942 89.3845 105.496 89.6206 106.005C89.8566 106.513 90.2011 106.964 90.6298 107.325C91.0585 107.685 91.561 107.948 92.1019 108.093L108.439 138.962L115.033 133.865L96.9009 105.124C97.0843 104.198 96.9221 103.237 96.4451 102.423C95.9681 101.608 95.2093 100.998 94.3126 100.706C93.416 100.415 92.4436 100.462 91.5799 100.841C90.7161 101.219 90.021 101.902 89.6262 102.759H89.6261Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18 152.034C118.18 152.034 116.667 153.378 114.514 149.666C112.79 146.693 104.194 133.384 102.977 128.77C102.31 128.789 101.655 128.585 101.116 128.19C100.577 127.795 100.184 127.232 100 126.589L109.233 123C111.24 124.005 110.683 125.398 110.174 126.119L113.613 131.284L125.051 144.138L119.292 151.081L118.18 152.034Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.502 308.999H0.498033C0.365946 308.999 0.239264 308.947 0.145864 308.853C0.0524641 308.76 0 308.633 0 308.501C0 308.368 0.0524641 308.242 0.145864 308.148C0.239264 308.055 0.365946 308.002 0.498033 308.002H272.502C272.634 308.002 272.761 308.055 272.854 308.148C272.948 308.242 273 308.368 273 308.501C273 308.633 272.948 308.76 272.854 308.853C272.761 308.947 272.634 308.999 272.502 308.999Z",
    fill: "#CCCCCC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M207.383 30.6528C202.474 25.807 195.918 23.1325 189.344 21.4215C181.902 19.4846 174.206 18.3437 166.603 17.2491C158.68 16.1083 150.725 15.2284 142.739 14.6094C134.764 13.9936 126.774 13.6411 118.769 13.5519C111.637 13.4719 104.457 13.4694 97.3592 14.2618C90.6741 15.0082 84.0051 16.506 77.9782 19.5808C72.6133 22.259 68.1061 26.3903 64.9686 31.5054C62.0842 36.2665 60.3693 41.974 60.9656 47.5706C61.2453 50.3265 62.1022 52.9924 63.4803 55.3942C65.0957 58.0484 67.1544 60.405 69.5665 62.3613C74.5464 66.5723 80.5004 69.6506 84.7844 74.6553C85.9157 75.9664 86.9038 77.3948 87.7321 78.9161C88.3542 80.0698 89.0539 81.0627 90.2109 81.7358C91.2437 82.326 92.4279 82.5968 93.6142 82.514C94.8005 82.4312 95.9357 81.9986 96.8768 81.2706C98.2113 80.2216 99.1697 78.6048 100.202 77.274L103.803 72.6334C104.064 72.2173 104.365 71.8286 104.703 71.4732C104.946 71.2723 104.546 71.4493 104.625 71.3993C104.669 71.3717 104.746 71.387 104.793 71.3674C105.033 71.2985 105.279 71.2528 105.528 71.2308C108.157 70.7467 110.792 70.2938 113.433 69.8724C123.183 68.297 132.996 66.9974 142.85 66.297C147.929 65.8908 153.027 65.769 158.12 65.9322C164.705 66.2021 171.199 67.5115 177.76 68.0764C184.824 68.6846 192.244 68.6006 198.901 65.8729C204.228 63.6897 209.175 60.0166 212.06 54.9434C213.429 52.544 214.24 49.8665 214.432 47.1099C214.784 40.8574 211.748 34.9614 207.383 30.6528Z",
    fill: "url(#paint24_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.832 19C113.576 19 112.32 19.0067 111.065 19.02C99.0174 19.148 86.566 20.1235 77.1171 26.3425C68.7303 31.8626 62.8524 44.1585 67.8268 52.9766C70.111 57.0257 74.2496 59.9731 78.6312 63.0933C80.3485 64.3165 82.1247 65.5813 83.8268 66.9434C87.545 69.9189 91.0463 73.9122 93.0606 78.4023L101.908 67.0008L103.579 66.6803C105.187 66.3721 143.195 59.1548 163.437 61.4979C165.299 61.7134 167.18 61.9614 169 62.2012C177.223 63.2847 184.99 64.3074 192.447 62.7972C200.231 61.2197 208.779 55.1992 209.288 47.1482C209.636 41.6364 206.055 35.5899 200.166 31.7439C194.21 27.8553 186.783 26.2497 179.686 24.9385C158.293 20.991 136.585 19.0033 114.832 19Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5828 103.725C96.9465 103.725 100.484 100.183 100.484 95.8128C100.484 91.4429 96.9465 87.9004 92.5828 87.9004C88.2191 87.9004 84.6816 91.4429 84.6816 95.8128C84.6816 100.183 88.2191 103.725 92.5828 103.725Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5939 193.113C70.7272 191.407 70.0564 188.965 68.0957 187.659C66.1349 186.352 63.6267 186.676 62.4934 188.382C61.3601 190.088 62.0309 192.53 63.9917 193.836C65.9524 195.142 68.4606 194.819 69.5939 193.113Z",
    fill: "url(#paint25_linear_222_39137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.121 192.574C240.255 190.868 239.584 188.426 237.623 187.12C235.662 185.813 233.154 186.137 232.021 187.843C230.887 189.549 231.558 191.991 233.519 193.297C235.48 194.603 237.988 194.28 239.121 192.574Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.125 130.999C176.258 129.294 175.588 126.852 173.627 125.545C171.666 124.239 169.158 124.563 168.025 126.269C166.891 127.975 167.562 130.416 169.523 131.723C171.484 133.029 173.992 132.705 175.125 130.999Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.081 299.901H144.464L142.268 282.068H149.081V299.901Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 307.913H148.208L147.617 304.783L146.103 307.913H137.322C136.901 307.913 136.491 307.778 136.152 307.528C135.813 307.279 135.562 306.927 135.437 306.524C135.312 306.122 135.318 305.69 135.456 305.292C135.593 304.893 135.854 304.549 136.2 304.309L143.213 299.46V296.295L150.588 296.736L151.518 307.913Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.148 299.901H118.531L116.334 282.068H123.148V299.901Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.585 307.913H122.274L121.683 304.783L120.169 307.913H111.388C110.967 307.913 110.557 307.778 110.218 307.528C109.879 307.279 109.629 306.927 109.504 306.524C109.378 306.122 109.385 305.69 109.522 305.292C109.659 304.893 109.92 304.549 110.266 304.309L117.279 299.46V296.295L124.655 296.736L125.585 307.913Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.074 284.524H151.024L150.136 255.528C150.71 254.418 151.002 253.183 150.985 251.933C150.967 250.683 150.642 249.457 150.037 248.363L149.909 248.133L150.239 246.603C150.662 244.637 150.468 242.588 149.683 240.737L148.855 213.69C151.814 194.484 137.711 181.959 137.711 181.959H116.584L112.049 197.564C109.05 226.819 109.594 255.326 114.352 282.945L114.223 283.01C113.756 283.172 113.555 283.82 113.775 284.458C113.995 285.095 114.552 285.482 115.019 285.32L126.176 284.932C126.643 284.77 126.844 284.122 126.624 283.484C126.404 282.846 125.847 282.46 125.38 282.622L124.621 283.006L126.239 255.026L126.06 249.916L126.43 244.118L128.14 218.038L134.613 250.108L141.225 284.847C141.043 285.012 140.915 285.229 140.858 285.469C140.801 285.708 140.819 285.96 140.907 286.189C140.996 286.419 141.153 286.616 141.356 286.755C141.559 286.894 141.799 286.968 142.046 286.967H151.074C151.398 286.967 151.708 286.839 151.937 286.61C152.166 286.38 152.294 286.07 152.294 285.746C152.294 285.422 152.166 285.111 151.937 284.882C151.708 284.653 151.398 284.524 151.074 284.524Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.892 203.606C140.369 203.312 140.775 202.917 141.083 202.448C141.391 201.98 141.592 201.449 141.673 200.894C141.754 200.34 141.713 199.774 141.552 199.237C141.391 198.7 141.114 198.204 140.741 197.786L143.977 163L135.672 163.642L135.103 197.634C134.442 198.308 134.052 199.201 134.005 200.144C133.958 201.087 134.258 202.014 134.848 202.75C135.439 203.486 136.278 203.98 137.208 204.138C138.137 204.295 139.092 204.106 139.892 203.606Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.695 145.004C142.695 145.004 144.697 144.711 144.465 148.998C144.28 152.43 145.162 173.584 143.654 178.111C144.223 178.462 144.659 178.992 144.894 179.618C145.128 180.244 145.148 180.931 144.95 181.57L135.264 179.502C134.135 177.56 134.369 175.566 135.189 175.242L135.141 169.035L133 148.572L141.244 145.191L142.695 145.004Z",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9072 48H96.1777L91.7412 40.9385V48H90.0117V38.0469H91.7412L96.1914 45.1357V38.0469H97.9072V48ZM99.4795 44.2334C99.4795 43.5088 99.623 42.8571 99.9102 42.2783C100.197 41.695 100.601 41.2484 101.12 40.9385C101.64 40.624 102.237 40.4668 102.911 40.4668C103.909 40.4668 104.718 40.7881 105.338 41.4307C105.962 42.0732 106.299 42.9255 106.35 43.9873L106.356 44.377C106.356 45.1061 106.215 45.7578 105.933 46.332C105.655 46.9062 105.254 47.3506 104.729 47.665C104.21 47.9795 103.608 48.1367 102.925 48.1367C101.881 48.1367 101.045 47.7904 100.416 47.0977C99.7917 46.4004 99.4795 45.473 99.4795 44.3154V44.2334ZM101.141 44.377C101.141 45.138 101.298 45.735 101.612 46.168C101.927 46.5964 102.364 46.8105 102.925 46.8105C103.485 46.8105 103.921 46.5918 104.23 46.1543C104.545 45.7168 104.702 45.0765 104.702 44.2334C104.702 43.486 104.54 42.8936 104.217 42.4561C103.898 42.0186 103.463 41.7998 102.911 41.7998C102.369 41.7998 101.938 42.0163 101.619 42.4492C101.3 42.8776 101.141 43.5202 101.141 44.377ZM119.304 48H117.574L113.138 40.9385V48H111.408V38.0469H113.138L117.588 45.1357V38.0469H119.304V48ZM120.876 44.2334C120.876 43.5088 121.02 42.8571 121.307 42.2783C121.594 41.695 121.997 41.2484 122.517 40.9385C123.036 40.624 123.633 40.4668 124.308 40.4668C125.306 40.4668 126.115 40.7881 126.734 41.4307C127.359 42.0732 127.696 42.9255 127.746 43.9873L127.753 44.377C127.753 45.1061 127.612 45.7578 127.329 46.332C127.051 46.9062 126.65 47.3506 126.126 47.665C125.606 47.9795 125.005 48.1367 124.321 48.1367C123.278 48.1367 122.441 47.7904 121.812 47.0977C121.188 46.4004 120.876 45.473 120.876 44.3154V44.2334ZM122.537 44.377C122.537 45.138 122.694 45.735 123.009 46.168C123.323 46.5964 123.761 46.8105 124.321 46.8105C124.882 46.8105 125.317 46.5918 125.627 46.1543C125.941 45.7168 126.099 45.0765 126.099 44.2334C126.099 43.486 125.937 42.8936 125.613 42.4561C125.294 42.0186 124.859 41.7998 124.308 41.7998C123.765 41.7998 123.335 42.0163 123.016 42.4492C122.697 42.8776 122.537 43.5202 122.537 44.377ZM131.239 38.8057V40.6035H132.545V41.834H131.239V45.9629C131.239 46.2454 131.294 46.4505 131.403 46.5781C131.517 46.7012 131.718 46.7627 132.005 46.7627C132.196 46.7627 132.39 46.7399 132.586 46.6943V47.9795C132.208 48.0843 131.843 48.1367 131.492 48.1367C130.216 48.1367 129.578 47.4326 129.578 46.0244V41.834H128.361V40.6035H129.578V38.8057H131.239ZM135.587 48H133.926V40.6035H135.587V48ZM133.823 38.6826C133.823 38.4274 133.903 38.2155 134.062 38.0469C134.227 37.8783 134.459 37.7939 134.76 37.7939C135.061 37.7939 135.293 37.8783 135.457 38.0469C135.621 38.2155 135.703 38.4274 135.703 38.6826C135.703 38.9333 135.621 39.1429 135.457 39.3115C135.293 39.4756 135.061 39.5576 134.76 39.5576C134.459 39.5576 134.227 39.4756 134.062 39.3115C133.903 39.1429 133.823 38.9333 133.823 38.6826ZM137.986 48V41.834H136.858V40.6035H137.986V39.9268C137.986 39.1064 138.214 38.473 138.67 38.0264C139.126 37.5798 139.764 37.3564 140.584 37.3564C140.876 37.3564 141.186 37.3975 141.514 37.4795L141.473 38.7783C141.29 38.7419 141.078 38.7236 140.837 38.7236C140.044 38.7236 139.647 39.1315 139.647 39.9473V40.6035H141.151V41.834H139.647V48H137.986ZM144.132 48H142.471V40.6035H144.132V48ZM142.368 38.6826C142.368 38.4274 142.448 38.2155 142.607 38.0469C142.771 37.8783 143.004 37.7939 143.305 37.7939C143.605 37.7939 143.838 37.8783 144.002 38.0469C144.166 38.2155 144.248 38.4274 144.248 38.6826C144.248 38.9333 144.166 39.1429 144.002 39.3115C143.838 39.4756 143.605 39.5576 143.305 39.5576C143.004 39.5576 142.771 39.4756 142.607 39.3115C142.448 39.1429 142.368 38.9333 142.368 38.6826ZM148.985 46.8105C149.4 46.8105 149.744 46.6898 150.018 46.4482C150.291 46.2067 150.437 45.9082 150.455 45.5527H152.021C152.002 46.013 151.859 46.4437 151.59 46.8447C151.321 47.2412 150.956 47.5557 150.496 47.7881C150.036 48.0205 149.539 48.1367 149.006 48.1367C147.971 48.1367 147.151 47.8018 146.545 47.1318C145.939 46.4619 145.636 45.5368 145.636 44.3564V44.1855C145.636 43.0599 145.937 42.1598 146.538 41.4854C147.14 40.8063 147.96 40.4668 148.999 40.4668C149.879 40.4668 150.594 40.7243 151.146 41.2393C151.701 41.7497 151.993 42.4219 152.021 43.2559H150.455C150.437 42.832 150.291 42.4834 150.018 42.21C149.749 41.9365 149.405 41.7998 148.985 41.7998C148.448 41.7998 148.033 41.9958 147.741 42.3877C147.45 42.7751 147.301 43.3652 147.297 44.1582V44.4248C147.297 45.2269 147.44 45.8262 147.728 46.2227C148.019 46.6146 148.438 46.8105 148.985 46.8105ZM157.694 48C157.621 47.8587 157.558 47.6286 157.503 47.3096C156.974 47.861 156.327 48.1367 155.562 48.1367C154.819 48.1367 154.213 47.9248 153.743 47.501C153.274 47.0771 153.039 46.5531 153.039 45.9287C153.039 45.1403 153.331 44.5365 153.914 44.1172C154.502 43.6934 155.34 43.4814 156.43 43.4814H157.448V42.9961C157.448 42.6133 157.341 42.3079 157.127 42.0801C156.913 41.8477 156.587 41.7314 156.149 41.7314C155.771 41.7314 155.461 41.8271 155.22 42.0186C154.978 42.2054 154.857 42.4447 154.857 42.7363H153.196C153.196 42.3307 153.331 41.9525 153.6 41.6016C153.868 41.2461 154.233 40.9681 154.693 40.7676C155.158 40.5671 155.675 40.4668 156.245 40.4668C157.111 40.4668 157.801 40.6855 158.316 41.123C158.831 41.556 159.096 42.1667 159.109 42.9551V46.291C159.109 46.9564 159.203 47.4873 159.39 47.8838V48H157.694ZM155.869 46.8037C156.197 46.8037 156.505 46.724 156.792 46.5645C157.084 46.4049 157.302 46.1908 157.448 45.9219V44.5273H156.553C155.938 44.5273 155.475 44.6344 155.165 44.8486C154.855 45.0628 154.7 45.3659 154.7 45.7578C154.7 46.0768 154.805 46.332 155.015 46.5234C155.229 46.7103 155.514 46.8037 155.869 46.8037ZM162.931 38.8057V40.6035H164.236V41.834H162.931V45.9629C162.931 46.2454 162.985 46.4505 163.095 46.5781C163.209 46.7012 163.409 46.7627 163.696 46.7627C163.888 46.7627 164.081 46.7399 164.277 46.6943V47.9795C163.899 48.0843 163.535 48.1367 163.184 48.1367C161.908 48.1367 161.27 47.4326 161.27 46.0244V41.834H160.053V40.6035H161.27V38.8057H162.931ZM167.278 48H165.617V40.6035H167.278V48ZM165.515 38.6826C165.515 38.4274 165.594 38.2155 165.754 38.0469C165.918 37.8783 166.15 37.7939 166.451 37.7939C166.752 37.7939 166.984 37.8783 167.148 38.0469C167.312 38.2155 167.395 38.4274 167.395 38.6826C167.395 38.9333 167.312 39.1429 167.148 39.3115C166.984 39.4756 166.752 39.5576 166.451 39.5576C166.15 39.5576 165.918 39.4756 165.754 39.3115C165.594 39.1429 165.515 38.9333 165.515 38.6826ZM168.782 44.2334C168.782 43.5088 168.926 42.8571 169.213 42.2783C169.5 41.695 169.903 41.2484 170.423 40.9385C170.942 40.624 171.539 40.4668 172.214 40.4668C173.212 40.4668 174.021 40.7881 174.641 41.4307C175.265 42.0732 175.602 42.9255 175.652 43.9873L175.659 44.377C175.659 45.1061 175.518 45.7578 175.235 46.332C174.957 46.9062 174.556 47.3506 174.032 47.665C173.513 47.9795 172.911 48.1367 172.228 48.1367C171.184 48.1367 170.348 47.7904 169.719 47.0977C169.094 46.4004 168.782 45.473 168.782 44.3154V44.2334ZM170.443 44.377C170.443 45.138 170.601 45.735 170.915 46.168C171.229 46.5964 171.667 46.8105 172.228 46.8105C172.788 46.8105 173.223 46.5918 173.533 46.1543C173.848 45.7168 174.005 45.0765 174.005 44.2334C174.005 43.486 173.843 42.8936 173.52 42.4561C173.201 42.0186 172.765 41.7998 172.214 41.7998C171.672 41.7998 171.241 42.0163 170.922 42.4492C170.603 42.8776 170.443 43.5202 170.443 44.377ZM178.605 40.6035L178.653 41.458C179.2 40.7972 179.918 40.4668 180.807 40.4668C182.347 40.4668 183.131 41.3486 183.158 43.1123V48H181.497V43.208C181.497 42.7386 181.395 42.3923 181.189 42.1689C180.989 41.9411 180.659 41.8271 180.198 41.8271C179.528 41.8271 179.029 42.1302 178.701 42.7363V48H177.04V40.6035H178.605Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_39137",
    x1: 200.354,
    y1: 310.238,
    x2: 146.568,
    y2: 293.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_39137",
    x1: 159.671,
    y1: 284.237,
    x2: 201.354,
    y2: 284.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_39137",
    x1: 189.62,
    y1: 283.355,
    x2: 199.573,
    y2: 283.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_39137",
    x1: 175.791,
    y1: 285.703,
    x2: 178.792,
    y2: 285.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_222_39137",
    x1: 194.976,
    y1: 269.644,
    x2: 198.118,
    y2: 269.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_222_39137",
    x1: 173.073,
    y1: 311.481,
    x2: 137.236,
    y2: 305.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_222_39137",
    x1: 152.939,
    y1: 278.532,
    x2: 166.659,
    y2: 278.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_222_39137",
    x1: 166.026,
    y1: 269.972,
    x2: 173.681,
    y2: 269.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_222_39137",
    x1: 155.584,
    y1: 281.353,
    x2: 160.721,
    y2: 281.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_222_39137",
    x1: 160.02,
    y1: 258.526,
    x2: 164.68,
    y2: 258.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_222_39137",
    x1: 45.6538,
    y1: 238.726,
    x2: 121.263,
    y2: 238.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_222_39137",
    x1: 174.217,
    y1: 118.66,
    x2: 225.164,
    y2: 118.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_222_39137",
    x1: 54.1034,
    y1: 42.7996,
    x2: 180.242,
    y2: 42.7996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_222_39137",
    x1: 165.71,
    y1: 223.2,
    x2: 235.458,
    y2: 223.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_222_39137",
    x1: 260.435,
    y1: 92.2472,
    x2: 267.63,
    y2: 92.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_222_39137",
    x1: 27.3452,
    y1: 147.514,
    x2: 54.9767,
    y2: 147.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_222_39137",
    x1: 45.1616,
    y1: 261.372,
    x2: 120.771,
    y2: 261.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_222_39137",
    x1: 173.725,
    y1: 141.307,
    x2: 224.671,
    y2: 141.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_222_39137",
    x1: 96.2753,
    y1: 66.7018,
    x2: 222.414,
    y2: 66.7018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_222_39137",
    x1: 164.382,
    y1: 253.804,
    x2: 234.13,
    y2: 253.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_222_39137",
    x1: 259.942,
    y1: 114.893,
    x2: 267.138,
    y2: 114.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_222_39137",
    x1: 26.853,
    y1: 170.159,
    x2: 54.4846,
    y2: 170.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_222_39137",
    x1: 250.723,
    y1: 99.2977,
    x2: 241.55,
    y2: 96.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_222_39137",
    x1: 62.7628,
    y1: 231.197,
    x2: 53.5905,
    y2: 228.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_222_39137",
    x1: 60.8665,
    y1: 48.0438,
    x2: 214.461,
    y2: 48.0438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_222_39137",
    x1: 61.9434,
    y1: 190.75,
    x2: 70.1451,
    y2: 190.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_39137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 309,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no-notifications.2798b0f4011760adb7e7091e72de3ea0.svg";
export { ForwardRef as ReactComponent };